import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CamMainRoute, CamRoutes } from '@camelot/menu';
import { AuthGuard, LoginRedirectComponent } from '@camelot/user';

import { NotFoundPage } from './features/base/not-found/not-found.component';
import { EShowcaseRoute, showcaseRoutes } from './features/showcase/showcase.routes';
import { AppStyleRoutingModule, EStyleRoute } from './features/styles/app-routing.module';

AppStyleRoutingModule.loadRoutes();

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: CamRoutes.getUrl([EShowcaseRoute.showcase]),
  },
  {
    path: CamRoutes.getUrl([CamMainRoute.USERLOGIN]),
    component: LoginRedirectComponent,
  },
  {
    children: showcaseRoutes,
    path: CamRoutes.getUrl([EShowcaseRoute.showcase]),
  },
  {
    loadChildren: () => import('./features/styles/styles.module').then(m => m.AppStylesModule),
    path: CamRoutes.getUrl([EStyleRoute.styles]),
  },
  {
    loadComponent: () => import('@camelot/testing-harness').then(m => m.HarnessComponent),
    path: 'e2e-harness/:caseId',
  },
  {
    canActivate: [AuthGuard],
    loadComponent: () => import('@camelot/testing-harness').then(m => m.HarnessComponent),
    path: 'e2e-guarded',
  },
  {
    component: NotFoundPage,
    path: '**',
  },
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes)],
})
export class AppRoutingModule {}
